module.exports = __webpack_public_path__ + "img/wochenblatt-article.0bd21092.jpg";